import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {hasAnyAuthority, ROLE} from '../app.constants';
import {map} from 'rxjs';

export const hasAnyRoleGuard: CanActivateFn = (route, state) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  const requiredRoles: ROLE[] = route.data?.['roles'];

  if (!requiredRoles) {
    console.error('❌ hasAnyRoleGuard: No roles specified in route data for path:', route.routeConfig?.path || state.url);
    console.error('You must add roles to your route configuration: data: { roles: [\'role1\', \'role2\'] }');
    return false;
  }

  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    console.error('❌ hasAnyRoleGuard: Invalid roles configuration for path:', route.routeConfig?.path || state.url);
    console.error('Roles must be a non-empty array. Current value:', requiredRoles);
    return false;
  }

  return oidcSecurityService.userData$.pipe(
    map(userData => {
      if (userData && userData.userData) {
        const hasRequiredRole = hasAnyAuthority(userData, requiredRoles);

        // Development logging
        if (!hasRequiredRole) {
          console.warn('🔒 hasAnyRoleGuard: Access denied for path:', route.routeConfig?.path || state.url);
          // Access denied - redirect to welcome
          return router.createUrlTree(['welcome']);
        }

        return hasRequiredRole;
      }
      // No user data - return false
      return false;
    })
  );
};
